class CartNotification extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.closest('.cart-notification-modal');
      this.continueButton = this.querySelector('.cart-notification__continue');
      this.cartButton = this.querySelector('#cart-notification-button');
    }
  
    connectedCallback() {
      this.onClickContinueHandler = this.onClickContinue.bind(this);
      this.onClickCartHandler = this.onClickCart.bind(this);
      this.continueButton.addEventListener('click', this.onClickContinueHandler);
      if (this.cartButton) {
        this.cartButton.addEventListener('click', this.onClickCartHandler);
      }
      
      // Listen for cart updates to refresh progress bar
      this.cartUpdateHandler = this.onCartUpdate.bind(this);
      document.addEventListener('afterCartChanged', this.cartUpdateHandler);
      
      // Also listen for pub/sub cart updates
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.pubSubUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source !== 'cart-items') {
            this.onCartUpdate(event);
          }
        });
      }
    }
  
    disconnectedCallback() {
      this.continueButton.removeEventListener('click', this.onClickContinueHandler);
      if (this.cartButton) {
        this.cartButton.removeEventListener('click', this.onClickCartHandler);
      }
      document.removeEventListener('afterCartChanged', this.cartUpdateHandler);
      if (this.pubSubUnsubscriber) {
        this.pubSubUnsubscriber();
      }
    }
  
    renderContents(parsedState) {
      // Use the key from the response or generate one if not available 
      this.cartItemKey = parsedState.key || parsedState.id || 'latest';
      
      this.getSectionsToRender().forEach((section) => {
        const element = document.getElementById(section.id);
        if (element && parsedState.sections && parsedState.sections[section.id]) {
          element.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        }
      });

      this.open();
      
      // Load recommendations after popup is shown
      // this.loadRecommendations(parsedState);
      
      // Update progress bar with new cart total
      this.updateProgressBar(parsedState);
      
      setTimeout(() => {
        const freeProductSlider = document.querySelector(".cart__recommendation-list slider-component");
        if(freeProductSlider) freeProductSlider.init();
      }, 100);
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `[id="cart-notification-product-${this.cartItemKey}"]`
        },
        {
          id: 'cart-notification-progress-bar',
          selector: '.cart-notification-progress-bar'
        },
        {
          id: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }
  
    open() {
      this.dialog.show(this.activeElement);
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  
    onClickContinue() {
      this.dialog.hide();
    }

    onClickCart() {
      // Close the cart notification dialog
      this.dialog.hide();
      
      // Open the cart drawer
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.open();
      }
    }

    updateProgressBar(parsedState) {
      // Find the free shipping bar element in the cart notification
      const freeShippingBar = this.querySelector('free-shipping-bar');
      if (!freeShippingBar) return;

      // Calculate the new total price from cart items
      let calculatedTotalPrice = 0;
      if (parsedState.items) {
        parsedState.items.forEach(item => {
          if (item.requires_shipping) {
            calculatedTotalPrice += item.final_line_price;
          }
        });
      }

      // Update the data-total-price attribute to trigger the progress bar update
      // freeShippingBar.setAttribute('data-total-price', calculatedTotalPrice);
    }

    onCartUpdate(event) {
      // When cart is updated, refresh the progress bar if the cart notification is open
      if (true) {
        // Fetch the current cart state and update the progress bar
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            this.updateProgressBarFromCart(cart);
          })
          .catch(error => {
            console.error('Error fetching cart state:', error); 
          });
      }
    }

    updateProgressBarFromCart(cart) {
      // Find the free shipping bar element in the cart notification
      const freeShippingBar = this.querySelector('free-shipping-bar');
      console.log("freeShippingBar:", freeShippingBar);
      console.log("cart:", cart);
      if (!freeShippingBar) return;
      

      // Calculate the new total price from cart items
      let calculatedTotalPrice = cart.total_price;

      const shippingMessage = document.querySelector('.shipping-bar__message');
      const missingAmount = (freeShippingBar.dataset.threshold - calculatedTotalPrice) / 100;
      const missingAmountFormatted = missingAmount.toFixed(2);
      if (shippingMessage && calculatedTotalPrice < freeShippingBar.dataset.threshold) {
      shippingMessage.innerHTML = `Dir fehlt noch <strong>${missingAmountFormatted}€</strong> für kostenlosen Versand!`;
      } else if (shippingMessage && calculatedTotalPrice >= freeShippingBar.dataset.threshold) {
        shippingMessage.innerHTML = `Du erhältst <strong>kostenlosen Versand!</strong>`;
      }

      // Update the data-total-price attribute to trigger the progress bar update
      freeShippingBar.setAttribute('data-total-price', calculatedTotalPrice);
    }
  }
  
  customElements.define('cart-notification', CartNotification); 